import { jsService } from "@/utils/request";

// 类型获取客服
export const postCustomerServiceTypeApi = (data = {}) =>
  jsService({
    url: "/customer-service/type",
    method: "post",
    data,
  });

// 获取页脚链接列表
export const postCustomerServiceFooterApi = (data = {}) =>
  jsService({
    url: "/customer-service/footer",
    method: "post",
    data,
  });

// 获取投注限额
export const postSettingsKeyApi = (data = {}) =>
  jsService({
    url: "/settings/key",
    method: "post",
    data,
  });
